import styled from 'styled-components';
import { Modal, Form, Divider } from 'antd';

export const Container = styled.div`
  @media screen and (max-width: 1200px) {
    flex-wrap: wrap;
  }
`;
